import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { AppInformationService, ArkUnitOfWork, AuthService, UtilityService } from '../../core/core.module';
import _ from 'lodash';
import { confirm, alert } from 'devextreme/ui/dialog';

@Component({
    selector: 'app-proposal-dialog',
    templateUrl: './proposal-dialog.component.html',
    styleUrls: ['./proposal-dialog.component.scss'],
    standalone: false,
})
export class ProposalDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    proposal: any;
    committees: any;
    saving = false;

    votes: any;
    discussions: any;
    initialDiscussion: any;
    mode: any;
    congregationalVotes = 0;
    clerkReview = false;
    executiveAdmin = false;
    totalVotes = 0;
    yesVotes = 0;
    noVotes = 0;

    constructor(public modalRef: BsModalRef, private uow: ArkUnitOfWork, private appInfo: AppInformationService, private auth: AuthService, private utility: UtilityService) {}

    async ngOnInit() {
        this.clerkReview = this.auth.hasRole('Executive:Clerk');
        this.executiveAdmin = this.auth.hasRole('Executive:Admin');
        this.committees = this.uow.lookups.allCommittees;

        if (!this.proposal) {
            this.proposal = this.uow.proposals.createEntity();
            this.proposal.created = new Date();
            this.proposal.createdBy = this.auth.currentUser.userName;
            this.mode = 'new';
        } else {
            await this.getData();
        }
    }

    async getData() {
        this.votes = await this.uow.getVotesByProposalId(this.proposal.id, 'person');
        this.discussions = await this.uow.getDiscussionByProposalId(this.proposal.id, 'person');
        this.congregationalVotes = (await this.utility.getUnSentCongregationalProposals(this.proposal.id)) as number;
        this.votes.forEach((x) => {
            this.yesVotes += x.yesVote ? 1 : 0;
            this.noVotes += x.noVote ? 1 : 0;
        });
    }

    addCustomItem(data) {
        if (!data.text) {
            data.customItem = null;
            return;
        }
        const newCommitteeId = this.committees.length > 0 ? (_.maxBy(this.committees, 'id') as any).id + 1 : 1;
        this.committees.push({ id: newCommitteeId, name: data.text });
    }

    async sendGeneratedVotes() {
        const response = await confirm(
            `This will send all UNSENT votes to congregational members.  Continue?  This will take some time based on the number of votes to send.`,
            `${this.appInfo.settings.church.toUpperCase()}`
        );
        if (!response) return;

        this.appInfo.pleaseWaitShow();
        try {
            const result = await this.utility.sendCongregationalProposalVotes(this.proposal.id, this.auth.currentUser.userName);
            await this.getData();
            this.appInfo.pleaseWaitHide();
            const status = await alert(`${result}`, `${this.appInfo.settings.church.toUpperCase()}`);
        } catch (error) {
            console.log(error);
            await alert(`Error sending emails.  Contact system admin. ${error}`, `${this.appInfo.settings.church.toUpperCase()}`);
            this.appInfo.pleaseWaitHide();
        }
    }

    async save() {
        this.saving = true;
        await this.uow.commit();
        this.result.next({ success: true, value: this.proposal, initialDiscussion: this.proposal.allowDiscussion ? this.initialDiscussion : null });
    }

    close() {
        this.saving = true;
        this.uow.rollback();
        this.result.next(false);
    }
}
